import {
  ENTRY_TIMING_COLOR,
  entryTimingGradeLabel,
} from "portal/utils/entryTimingGrade";
import { EntryTimingGrade } from "protos/portal/metrics";
import { MetricRow } from "./certifiedMetrics/MetricSubsection";
import { Tooltip } from "@mui/material";
import { useMuiColor } from "common/hooks/useMuiColor";
import { useTranslation } from "react-i18next";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import React, { FunctionComponent } from "react";

export const EntryTimingGradeRow: FunctionComponent<{
  grade: EntryTimingGrade | undefined;
}> = ({ grade }) => {
  const { t } = useTranslation();
  const label = entryTimingGradeLabel(t, grade);
  const colorName = grade === undefined ? undefined : ENTRY_TIMING_COLOR[grade];

  const color = useMuiColor(colorName);
  if (label === undefined) {
    return;
  }

  return (
    <MetricRow>
      <span className="font-medium">
        {t("components.EntryTimingGrade.label")}
        <Tooltip arrow title={t("components.EntryTimingGrade.help")}>
          <InfoIcon
            color="disabled"
            fontSize="inherit"
            className="ms-1 align-middle"
            tabIndex={0}
          />
        </Tooltip>
      </span>
      <span style={{ color }}>{label}</span>
    </MetricRow>
  );
};
